// @i18n-ignore-start
export const ANALYTIC_COOKIES = {
  LB_USER_ID: '_lb_user_id',
  LB_USER_FIRST_ACCESS: '_lb_user_first_access',
  SESSION_ID: '_session_id',
  Q_COOKIE_ID: 'q-cookie-id',
  LB_USER_ID_SERVER: 'q_lb_user_id',
  SESSION_ID_SERVER: 'q_session_id',
  LB_CUSTOMER_EMAIL: '_lb_customer_email',
  LB_CUSTOMER_TENTATIVE_EMAIL: '_lb_customer_tentative_email',
  UTM_SOURCE: '_utm_source',
  UTM_CAMPAIGN: '_utm_campaign',
  UTM_MEDIUM: '_utm_medium',
  UTM_CONTENT: '_utm_content',
  UTM_TERM: '_utm_term',
  QCLID: '_qclid',
  UTM_SOURCE_SERVER: 'q_utm_source',
  UTM_CAMPAIGN_SERVER: 'q_utm_campaign',
  UTM_MEDIUM_SERVER: 'q_utm_medium',
  UTM_CONTENT_SERVER: 'q_utm_content',
  UTM_TERM_SERVER: 'q_utm_term',
  QCLID_SERVER: 'q_qclid',
  IS_PART_OF_NEW_SITE_LAUNCH_EXPERIMENT: '_is_part_of_new_site_launch_experiment',
  BUCKET_FOR_NEW_SITE_LAUNCH_EXPERIMENT: '_bucket_for_new_site_launch_experiment',
  IS_NEW_USER: '_is_new_user',
  ECOMM_IP: '_ecomm_ip',
  ECOMM_UA: '_ecomm_ua',
  MIXPANEL_USER_DEVICE_ID: '_mp_user_device_id', // Reset after logout to generate a new id
  MIXPANEL_TENTATIVE_EMAIL: '_mp_tentative_email',
  SLUG_TO_PAGE_CONTEXT_MAP_SESSION_STORAGE_KEY: 'slugToPageContextMap',
  CURRENT_PAGE_PATH: 'currentPagePath',
  PREVIOUS_PAGE_PATH: 'previousPagePath',
  CURRENT_PAGE_URL: 'currentPageUrl',
  PREVIOUS_PAGE_URL: 'previousPageUrl',
  IMPACT_CLICK_ID: 'impactClickId',
  PLATFORM_AB: 'platform_ab',
  CURRENT_FINDING_METHOD: 'currentFindingMethod',
  FINDING_METHODS: 'findingMethods',
  CURRENT_FINDING_METHOD_LB: 'currentFindingMethodLB',
  FINDING_METHODS_LB: 'findingMethodsLB',
  CURRENT_RECOMMENDATION_TAB_DATA_LB: 'currentRecommendationTabDataLB',
  RECOMMENDATION_TAB_DATA_BY_VARIANT_LB: 'recommendationTabDataByVariantLB',
  ZIP_CODE: 'zip-code',
  USER_ENTERED_ZIP_CODE: 'user-enter-zip-code',
  LB_CUSTOMER_ID: 'lb_customer_id',
  THIRD_PARTY: {
    GOOGLE_GA_ID: '_ga',
    FACEBOOK_FBC: '_fbc',
    FACEBOOK_FBP: '_fbp',
    TIKTOK_PIXEL: '_ttp',
  },
}
// @i18n-ignore-end

export const ANALYTIC_LOCAL_STORAGE_KEYS = {
  APP_ANALYTICS_DATA: 'app_analytics_data',
}

export const FEATURE_COOKIES = {
  IS_WELCOME_POPUP_PREVIOUSLY_OPENED: '_quince_welcome_popup',
  IS_ATTENTIVE_POPUP_PREVIOUSLY_OPENED: '_attentive_popup',
  CONTENT_ENV: 'content-env',
}

export const FEATURE_HEADERS = {
  CONTENT_ENV: 'x-content-env',
  CONTENT_ENV_MODE: 'x-content-env-mode',
}

export enum CONTENT_ENV_MODE_VALUES {
  LIVE = 'LIVE',
  PREVIEW = 'PREVIEW',
}

export const PROMO_SCRIPT_PREVIEW_COOKIES = {
  BFCM_DAY: '_bfcm_day',
  CART_ITEMS_FOR_BF_PREVIEW: '_cart_items_for_bf_preview',
}

export const ATTENTIVE_POP_UP_EXPIRY_MINUTES = 43200

export const ONE_YEAR_IN_MINUTES = 60 * 24 * 365

export const TRACKING_UNKNOWN_DATA_BY_CARRIER = `Please check the carrier’s tracking page for the most up to date tracking information. Sometimes it takes carriers a few days to update tracking. Thanks for your patience! Our orders typically arrive 6-9 business days after shipping. If your order has not arrived in this time frame and tracking appears to be stalled, please contact us at care@onequince.com. Our customer care team is here to help!`

export const CUSTOM_EVENTS = {
  DATA_LAYER_CHANGE: 'dataLayerChange',
}

export const DEFAULT_CURRENCY_CODE = 'USD'
// TODO_LOCALISATION @manas: Add translations for these constants once API is sending these keys translated, these are used for checks
// @i18n-ignore-start
export const WGD_PC_ADDITONAL_ATTRIBUTE_NAME = 'White Glove Delivery'
export const MF_PC_ADDITONAL_ATTRIBUTE_NAME = 'Membership Fee'
export const SERVING_PC_ADDITONAL_ATTRIBUTE_NAME = 'Servings'
export const PPS_PC_ADDITONAL_ATTRIBUTE_NAME = 'Price per serving'
export const FURNITURE_COVERS_PC_ADDITONAL_ATTRIBUTE_NAME = 'Furniture Covers'
export const OVERNIGHT_SHIPPING_PC_ADDITONAL_ATTRIBUTE_NAME = 'Overnight Shipping'

// TODO_LOCALISATION @manas: Add translations for these constants once API is sending these keys translated, these are used for checks
export const GROUP_OPTION_NAMES = {
  FABRIC: 'Fabric',
}
export const UTM_SOURCES = {
  BLAST: 'blast',
  FLOW: 'flow',
  SMS_BLAST: 'sms-blast',
  SMS_FLOW: 'sms-flow',
}
// @i18n-ignore-end
export const ATTENTIVE_POPUP_COOKIE_KEYS = {
  ATTENTIVE_POPUP_EMAIL: 'attentive_popup_email',
  ATTENTIVE_POPUP_SMS: 'attentive_popup_sms',
  ATTENTIVE_POPUP_LOGGEDIN: 'attentive_popup_loggedIn',
}

export const PLATFORMS = {
  APP: 'app',
  MWEB: 'mweb',
  WEB: 'web',
} as const

export const MAX_NUMBER_OF_COLOR_OPTIONS = 5
export const HARD_CODED_IMAGE_QUALITY = 60

export const QUINCE_DOMAIN = 'https://www.quince.com'
export const PRODUCT_TAGS_IMAGE_LIMIT = 2

export enum TAG_POSITION {
  TOP = 'top',
  BOTTOM = 'bottom',
}
export enum TAG_LOCATION {
  PRODUCT_CARD = 'card',
  PDP = 'pdp',
  QATC = 'qatc',
}
// @i18n-ignore
export const AB_PAGE_NEW_HOME_PAGE = 'new-home-page'

export const CF_COOKIE_VALUE_HEADER_PREFIX = 'xq-cf'
export const DEFAULT_CURRENCY = '$'

export const DYNAMIC_APP_LINK = 'https://quince.onelink.me/Kwva/app'

export const LOCAL_STORAGE_DEVICE_ID = 'device_id'

export const VIDEO_FORCE_POSITION = 2
